import { User } from "../ChatAIWS";

interface Props {
    data: User[];
}

export default function UsersTable({ data }: Props) {
    return (
        <table className="erp-table">
            <thead>
                <tr>
                    <th>Nombre</th>
                    <th>NIT</th>
                    <th>ID</th>
                    <th>Acciones</th>
                </tr>
            </thead>

            <tbody>
                {data.map(u => (
                    <tr key={u.id}>
                        <td>{u.name}</td>
                        <td>{u.nit}</td>
                        <td>{u.id}</td>
                        <td>
                            <button onClick={() => openProfile(u.id)}>
                                Abrir ficha
                            </button>
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
}

function openProfile(id: number) {
    window.open(`/erp/accounts/${id}`, "_blank");
}
